import currencySymbol from '../currencySymbol';

const formatCarMileageAllowance = (itinerary) => {
  if (!itinerary.priceInfo.mileageAllowance) return undefined;
  if (itinerary.priceInfo.mileageAllowance === 'UNL') return 'Unlimited mileage';
  if (+itinerary.priceInfo.mileageAllowance > 0) {
    const uom =
      itinerary.priceInfo.extraMileageUOM === 'MI' ? 'miles' : itinerary.priceInfo.extraMileageUOM;
    let miles = `${itinerary.priceInfo.mileageAllowance} ${uom} included`;
    if (itinerary.priceInfo.extraMileageCharge >= 0)
      miles += ` (${currencySymbol(itinerary.priceInfo.currencyCode)}${itinerary.priceInfo.extraMileageCharge} for every additional ${uom})`;
    return miles;
  }
  return undefined;
};

export default formatCarMileageAllowance;
